import { memo } from 'react'

import { Loader } from '../../styles/loader'

export default memo(Loader)
